import { TextField, MenuItem, Button, FormControl, FormLabel, Switch, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const SearchBrowseForm = () => {
  const [searchBrowseFormData, setSearchBrowseFormData] = useState({
    search_query: "",
    max_results: "",
    headless_browser: false,
    use_proxy: false,
    crawl_depth: "",
    scraping_mode: "API",
    output_format: "JSON",
  });

  const scrapingModeOptions = ["API", "Web Scraping", "Hybrid"];
  const outputFormatOptions = ["JSON", "HTML", "Text"];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setSearchBrowseFormData({
      ...searchBrowseFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(searchBrowseFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Search Query</FormLabel>
            <TextField
              name="search_query"
              value={searchBrowseFormData.search_query}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Maximum Number of Search Results</FormLabel>
            <TextField
              type="number"
              name="max_results"
              value={searchBrowseFormData.max_results}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Switch
                name="headless_browser"
                checked={searchBrowseFormData.headless_browser}
                onChange={handleChange}
              />
            }
            label="Use Headless Browser"
          />
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Switch
                name="use_proxy"
                checked={searchBrowseFormData.use_proxy}
                onChange={handleChange}
              />
            }
            label="Use Proxy"
          />
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Crawl Depth</FormLabel>
            <TextField
              type="number"
              name="crawl_depth"
              value={searchBrowseFormData.crawl_depth}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Scraping Mode</FormLabel>
            <TextField
              select
              name="scraping_mode"
              value={searchBrowseFormData.scraping_mode}
              onChange={handleChange}
            >
              {scrapingModeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Output Format</FormLabel>
            <TextField
              select
              name="output_format"
              value={searchBrowseFormData.output_format}
              onChange={handleChange}
            >
              {outputFormatOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchBrowseForm;
